import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { ICONS_COMMON } from "@/common/icons/icons-common";
import { renderIfTrue } from "@/utils/react-conditional";
import { defined } from "@/utils/variable-evaluation";
import React from "react";

export interface IPopupWrapperProps {
  onClose?: () => void;
  hideClose?: boolean;
  /** Hides only the top-right X; tapping the backdrop still closes. */
  hideCloseButton?: boolean;
  inlineStyle?: React.CSSProperties;
  children?: React.ReactNode;
}

export const PopupWrapper = React.memo(function PopupWrapper(
  props: IPopupWrapperProps
) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- backdrop click-to-dismiss is a mouse convenience; keyboard users have the dedicated close Button below
    <div
      style={defined(props.inlineStyle) ? props.inlineStyle : {}}
      className="absolute inset-0 z-9 flex h-full w-full animate-overlay-enter items-center overflow-auto overscroll-contain bg-overlay text-center backdrop-blur-sm motion-reduce:animate-none"
      onClick={
        props.hideClose
          ? undefined
          : props.onClose
            ? (e) => {
                e.stopPropagation();
                props.onClose!();
              }
            : undefined
      }
    >
      {renderIfTrue(
        defined(props.onClose) && !props.hideClose && !props.hideCloseButton,
        () => (
          <div className="fixed top-3.75 right-3.75 z-10">
            <Button
              dataTest="popup-close"
              buttonType={EButtonType.IconWithBackground}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation();
                props.onClose!();
              }}
            >
              {ICONS_COMMON.Close}
            </Button>
          </div>
        )
      )}
      <div className="m-auto max-w-[calc(100%-10px)] animate-popup-enter px-0 pt-20 pb-40 motion-reduce:animate-none">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- only guards event bubbling so clicking the popup content doesn't dismiss it */}
        <div
          onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
});
